/**
 * 腾讯内核 卡顿注入器
 *  限定于安卓
 * @export
 * @class TencentInject
 */
export default class TencentInject {
  constructor() {
    this._lastTime = 0;
    this._timeCount = 0;
  }

  /**
   * 如果是安卓浏览器下的腾讯系软件
   *
   * @static
   * @returns
   * @memberof TencentLagInject
   */
  static isSupported() {
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.match(/android|adr/i);
    let isTencent = ua.match(/mqqbrowser|qzone|qqbrowser|qq|micromessenger/i);

    return isAndroid && isTencent;
  }

  destroy() {
    this._lastTime = 0;
    this._timeCount = 0;
  }

  setLastTime(t) {
    let currentTime = t >>> 0;
    this._lastTime = currentTime;
  }

  /**
   * 播放进度时间值未变化，则视为卡顿
   */
  isLag(t, lagCount) {
    let currentTime = t >>> 0;
    if (this._lastTime !== currentTime) {
      this._lastTime = currentTime;
      this._timeCount = 0;
    } else {
      this._timeCount = lagCount + 1;
    }
    return this._timeCount;
  }
}
